module.exports = __webpack_public_path__ + "img/noPic.ce6fb98e.jpg";